<p-table

  [columns]="headers"
  [styleClass]="'btable'"
  [value]="[customTier]"
  id="custom-fee-table"
>

  <ng-template pTemplate="header" let-columns>
    <tr>
      <th class="custom-fee-sch-tbl-header" width="80px" *ngIf="tierConfirmRequired">Select</th>
      <th class="custom-fee-sch-tbl-header" [style.width.%]="col.width" *ngFor="let col of columns">
        {{col.header}}
      </th>
    </tr>
  </ng-template>

  <ng-template pTemplate="body" class="custom-fee-sch-tbl-body" let-tier>
    <tr>
      <td *ngIf="tierConfirmRequired" id="tier-confirm-td">
        <p-radioButton id="tier-confirm-radio" (onClick)="onTierConfirm()"></p-radioButton>
      </td>
      <td>
        <input type="text" class="form-control" id="monthlyFee" [(ngModel)]="tier.monthlyFee" name="monthlyFee"
               placeholder="" (input)="onTierChange(tier)" [disabled]="disabled">
      </td>
      <td>
        <input type="text" class="form-control" id="queryAllowance" [(ngModel)]="tier.queryAllowance"
               name="queryAllowance" placeholder="" (input)="onTierChange(tier)" [disabled]="disabled">
      </td>
      <td>
        <input type="text" class="form-control" id="overageCharge" [(ngModel)]="tier.overageCharge"
               name="overageCharge" placeholder="" (input)="onTierChange(tier)" [disabled]="disabled">
      </td>
    </tr>
  </ng-template>

</p-table>
<div class="mb-5" >
    <small i18n>The monthly fee covers the number of TNs, Blocks, and/or Codes returned, up to the allowance. Overage charges apply for each additional TN, Block, and/or Code returned above the allowance.</small>
  </div>
